import { ClubTable } from '@blocks';
import { useClubCollections, useUserClubs, useSelectUserClub } from '@queries';
import { typography, Spinner } from '@ui';
import { useMemo } from 'react';
import * as css from './StudentSettings.css';

export const StudentGolfBag = ({ activeUserId }: { activeUserId?: string }) => {
    const { data: clubs } = useClubCollections();
    const { data: userClubs } = useUserClubs(activeUserId);
    const { mutateAsync: selectClub } = useSelectUserClub(activeUserId);
    const userClubIds = useMemo(() => userClubs?.map((club) => club.id) || [], [userClubs]);

    return (
        <div className={css.bagSettings}>
            <p
                className={typography({
                    variant: 'h2',
                })}
            >
                Student golf bag
            </p>
            {!clubs ? (
                <Spinner size="l" />
            ) : (
                <ClubTable clubs={clubs} selectedClubs={userClubIds} onClubClick={selectClub} />
            )}
        </div>
    );
};
